import React from "react"
import Container from "react-bootstrap/Container"
import {getLocalStorageItem, objectLang} from "../functions"
import {PathLineClass} from "../elements/PathLineClass"

export class NoteViewCardClass extends React.Component {

    render() {

        const {auth, note, saveNoteHandler, closeNoteHandler} = this.props

        let lang = objectLang().language

        const availableScreenHeight = Math.trunc(window.screen.availHeight * 0.5)
        const styleTextarea = {
            height: availableScreenHeight,
            background: "beige"
        }

        return (
            <>
                {<PathLineClass documents={{path: note.path}}/>}
                <Container className={"mt-3 mt-lg-5 text-center"}>
                    <div className={"d-flex flex-wrap justify-content-center card mb-1"}>
                        <div className={"card-header card-note text-success d-flex justify-content-start"}>
                            <div className={"d-flex flex-nowrap align-items-center w-100"}>

                                <div className="flex-grow-1 pe-3" style={{minWidth: 0}}>
                                    <input
                                        placeholder={lang.body.createNotePage.placeholderName}
                                        type="text"
                                        className="form-control fs-2 text-primary text-center w-100"
                                        id="name"
                                        style={{background: "beige"}}
                                        defaultValue={note.name}
                                    />
                                </div>

                                <button
                                    id="button-save-note"
                                    className="btn btn-save text-success flex-shrink-0"
                                    type="button"
                                    aria-label="Save"
                                    disabled={!auth.isAuthenticated}
                                    onClick={saveNoteHandler}
                                >
                                    <i className="fa-solid fa-floppy-disk fs-1"/>
                                </button>

                                <button
                                    id="button-close-note"
                                    type="button"
                                    className="btn-close flex-shrink-0 fs-2 ms-lg-3"
                                    aria-label="Close"
                                    onClick={() => {
                                        const newNote = {
                                            _id: note._id,
                                            type: note.type,
                                            dateCreated: note.dateCreated,
                                            dateLastUse: note.dateLastUse,
                                            owner: note.owner,
                                            count: note.count,
                                            parentFolder: note.parentFolder,
                                            name: document.querySelector('#name').value,
                                            body: document.querySelector('#body-note').value,
                                            isShare: note.isShare
                                        }

                                        closeNoteHandler(getLocalStorageItem('note-DB'), newNote)
                                    }}
                                />

                            </div>
                        </div>
                        <div className={"card-body card-note"}>
                        <textarea
                            placeholder={lang.body.createNotePage.placeholderText}
                            className={"form-control fs-4 text-success"}
                            id={"body-note"}
                            style={styleTextarea}
                            defaultValue={note.body}
                        />
                        </div>
                    </div>
                </Container>
            </>
        )
    }
}